<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <TableLoading v-if="warehouse.publicId === '0'"/>
    <div v-else>
      <div class="row">
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted">
                        <h4 class="mb-3">{{warehouse.name}}</h4>
                        <p class="mb-2"><b>Description:</b> {{warehouse.description}}</p>
                        <p class="mb-2" v-if="warehouse.longi != null"><b>Location:</b> {{warehouse.longi}}, {{warehouse.lat}}</p>
                        <p class="mb-2">
                          <b>Status:</b>
                          <span v-if="warehouse.isActive" class="badge rounded-pill font-size-11 badge-soft-primary mx-1"> Active </span>
                          <span v-else class="badge rounded-pill font-size-11 badge-soft-dark mx-1"> Inactive </span>
                        </p>
                        <hr v-if="checkForPermission(edit_warehouse_permission)"/>
                        <div v-if="checkForPermission(edit_warehouse_permission)">
                          <div v-if="warehouse.isActive">
                            <b-button v-if="statusLoading" variant="dark" size="sm" class="px-5 py-2 text-white" disabled>
                              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                              Loading
                            </b-button>
                            <b-button v-else variant="danger" size="sm" class="px-5 py-2 text-white" @click="changeWarehouseStatus">
                              Deactivate
                            </b-button>
                          </div>
                          <div v-else>
                            <b-button v-if="statusLoading" variant="dark" size="sm" class="px-5 py-2 text-white" disabled>
                              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                              Loading
                            </b-button>
                            <b-button v-else variant="success" size="sm" class="px-5 py-2 text-white" @click="changeWarehouseStatus">
                              Activate
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="px-4 pb-4">
            <div class="row mb-4">
              <div class="col-3">
                <h2 class="card-title-desc">Warehouse Stock</h2>
              </div>
              <div class="col-4">
                <!--              <b-button variant="info" size="sm" class="py-2 text-white" type="submit">Download CSV</b-button>-->
              </div>
            </div>
            <stock-table :rows="warehouse.stock" :columns="columns" @updateStockInfo="updateStocks" @onSearch="searchFn"/>
            <!--          <b-pagination-->
            <!--              v-model="currentPage"-->
            <!--              :total-rows="warehouse"-->
            <!--              :per-page="perPage"-->
            <!--              size="lg"-->
            <!--              align="center"-->
            <!--              class="mt-3"-->
            <!--          />-->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import StockTable from "@/components/stock/stock-table";
import {SINGLE_WAREHOUSE} from "@/gql/stock";
import TableLoading from "@/components/TableLoading";
import { permissions } from "@/router/permissions";
import { mapActions } from "vuex";
import { successToast } from "@/components/successToast";

export default {
  page: {
    title: "Single Warehouse Stock",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, StockTable, PageHeader, Layout},
  name: "single-warehouse-stock",
  data() {
    return {
      title: "Single Warehouse Stock",
      items: [
        {
          text: "Stock",
          href: "/"
        },
        {
          text: "Single Warehouse Stock",
          active: true
        }
      ],
      warehouse: {
        publicId: '0',
        name: "",
        description: "",
        longi: "",
        lat: "",
        stock: []
      },
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      columns: [
        {
          field: 'productId',
          label: 'Product Name'
        },
        {
          field: 'productCode',
          label: 'Product Code'
        },
        {
          field: 'quantityCase',
          label: 'QTY (C/S)'
        },
        {
          field: 'quantityBall',
          label: 'QTY (Ball)'
        },
        {
          field: 'quantityPiece',
          label: 'QTY (Pieces)'
        },
        {
          field: 'quantity',
          label: 'Order Unit Qty'
        },
        {
          field: 'actions',
          label: 'Actions'
        },
      ],
      edit_warehouse_permission: permissions.edit_warehouse_permission,
      statusLoading: false,
    }
  },
  apollo: {
    warehouse: {
      query: SINGLE_WAREHOUSE,
      variables() {
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  methods: {
    ... mapActions({
      toggleWarehouseStatus: 'stock/toggleWarehouseStatus',
    }),
    updateStocks(){
      this.$apollo.queries.warehouse.refetch()
    },
    searchFn(data){
      this.searchKeyword = data
    },
    async changeWarehouseStatus() {
      this.statusLoading = true
      await this.toggleWarehouseStatus({id: this.$route.params.id}).then(resp => {
        if (resp.publicId) {
          successToast('Updated warehouse status.')
        }
      }).finally(() => {
        this.statusLoading = false
        this.updateStocks()
      })
    },
  }
}
</script>

<style scoped>

</style>
